export const classNameEnvironment = 'os-environment';
export const classNameEnvironmentFlexboxGlue = `${classNameEnvironment}-flexbox-glue`;
export const classNameEnvironmentFlexboxGlueMax = `${classNameEnvironmentFlexboxGlue}-max`;

export const dataAttributeHost = 'data-overlayscrollbars';
export const dataAttributeInitialize = 'data-overlayscrollbars-initialize';
export const dataAttributeHostOverflowX = `${dataAttributeHost}-overflow-x`;
export const dataAttributeHostOverflowY = `${dataAttributeHost}-overflow-y`;
export const dataValueHostOverflowVisible = 'overflowVisible';
export const dataValueHostScrollbarHidden = 'scrollbarHidden';
export const dataValueHostUpdating = 'updating';
export const classNamePadding = 'os-padding';
export const classNameViewport = 'os-viewport';
export const classNameViewportArrange = `${classNameViewport}-arrange`;
export const classNameContent = 'os-content';
export const classNameViewportScrollbarHidden = `${classNameViewport}-scrollbar-hidden`;
export const classNameOverflowVisible = `os-overflow-visible`;

export const classNameSizeObserver = 'os-size-observer';
export const classNameSizeObserverAppear = `${classNameSizeObserver}-appear`;
export const classNameSizeObserverListener = `${classNameSizeObserver}-listener`;
export const classNameSizeObserverListenerScroll = `${classNameSizeObserverListener}-scroll`;
export const classNameSizeObserverListenerItem = `${classNameSizeObserverListener}-item`;
export const classNameSizeObserverListenerItemFinal = `${classNameSizeObserverListenerItem}-final`;

export const classNameTrinsicObserver = 'os-trinsic-observer';

export const classNameScrollbarThemeNone = 'os-theme-none';
export const classNameScrollbar = 'os-scrollbar';
export const classNameScrollbarRtl = `${classNameScrollbar}-rtl`;
export const classNameScrollbarHorizontal = `${classNameScrollbar}-horizontal`;
export const classNameScrollbarVertical = `${classNameScrollbar}-vertical`;
export const classNameScrollbarTrack = `${classNameScrollbar}-track`;
export const classNameScrollbarHandle = `${classNameScrollbar}-handle`;
export const classNameScrollbarVisible = `${classNameScrollbar}-visible`;
export const classNameScrollbarCornerless = `${classNameScrollbar}-cornerless`;
export const classNameScrollbarTransitionless = `${classNameScrollbar}-transitionless`;
export const classNameScrollbarInteraction = `${classNameScrollbar}-interaction`;
export const classNameScrollbarUnusable = `${classNameScrollbar}-unusable`;
export const classNameScrollbarAutoHidden = `${classNameScrollbar}-auto-hidden`;
export const classNameScrollbarWheel = `${classNameScrollbar}-wheel`;
export const classNameScrollbarTrackInteractive = `${classNameScrollbarTrack}-interactive`;
export const classNameScrollbarHandleInteractive = `${classNameScrollbarHandle}-interactive`;
